import { Fonts, fonts } from '../__styling/settings/fonts'
import {
    ThemeMargins,
    metrics,
    CardMargins,
    ComponentMetrics,
    SiteMetrics,
} from '../__styling/settings/metrics'
import { FallbackImages } from '../__fallback-images'
import { sections } from './settings/sections'
import { PerthNowSectionValues } from './settings/sections/perthnow'
import { TheWestSectionValues } from './settings/sections/thewest'
import { SevenNewsSectionValues } from './settings/sections/sevennews'
import {
    CommonZIndex,
    TheWestZindex,
    zIndex,
    SevenNewsZindex,
    PerthNowZindex,
} from './settings/z-index'
import { Product } from '@news-mono/web-common'

export interface Theme {
    fallbackImages: FallbackImages
    kind: Product
    fonts: Fonts
    margins: ThemeMargins
    cards: CardMargins
    componentMetrics: ComponentMetrics
    siteMetrics: SiteMetrics
    section: string
    sectionValues:
        | TheWestSectionValues
        | PerthNowSectionValues
        | SevenNewsSectionValues
    zIndex: (TheWestZindex | PerthNowZindex | SevenNewsZindex) & CommonZIndex
    baseFontSize: number
}
type EmotionTheme = Theme
declare module '@emotion/react' {
    export interface Theme extends EmotionTheme {}
}

export const thewest: Theme = {
    kind: Product.TheWest,
    fonts: fonts.thewest,
    margins: metrics.thewest.margins,
    cards: metrics.thewest.cards,
    componentMetrics: metrics.thewest.componentMetrics,
    siteMetrics: metrics.thewest.siteMetrics,
    zIndex: { ...zIndex.thewest, ...zIndex.common },

    // This following properties are provided through route resolution in provide-route-resolved-data-to-theme.tsx
    fallbackImages: undefined as any,
    section: 'default',
    sectionValues: sections.thewest.default,
    baseFontSize: metrics.thewest.baseFontSize,
}

export const perthnow: Theme = {
    kind: Product.PerthNow,
    fonts: fonts.perthnow,
    margins: metrics.perthnow.margins,
    cards: metrics.perthnow.cards,
    componentMetrics: metrics.perthnow.componentMetrics,
    siteMetrics: metrics.perthnow.siteMetrics,
    zIndex: { ...zIndex.perthnow, ...zIndex.common },

    // This following properties are provided through route resolution in provide-route-resolved-data-to-theme.tsx
    fallbackImages: undefined as any,
    section: 'default',
    sectionValues: sections.perthnow.default,
    baseFontSize: metrics.perthnow.baseFontSize,
}

export const sevennews: Theme = {
    kind: Product.SevenNews,
    fonts: fonts.sevennews,
    margins: metrics.sevennews.margins,
    cards: metrics.sevennews.cards,
    componentMetrics: metrics.sevennews.componentMetrics,
    siteMetrics: metrics.sevennews.siteMetrics,
    zIndex: { ...zIndex.sevennews, ...zIndex.common },

    // This following properties are provided through route resolution in provide-route-resolved-data-to-theme.tsx
    fallbackImages: undefined as any,
    section: 'default',
    sectionValues: sections.sevennews.default,
    baseFontSize: metrics.sevennews.baseFontSize,
}

export const themes = [thewest, perthnow, sevennews]

export interface ThemeProps {
    theme: Theme
}
